import { PersonaModel } from '@mm/state/model/PersonaModel';
import { createContext } from 'use-context-selector';
import { useCurrentPageName } from './hooks/use-current-page-name';

type PersonaContextValue = {
  currentPersona: PersonaModel | undefined;
  fetchPersona: (personaId: number) => void;
};
export const PersonaContext = createContext({} as PersonaContextValue);

export const CurrentPageNameContext = createContext(
  {} as {
    getCurrentPageName: ReturnType<typeof useCurrentPageName>;
  },
);
